import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EChartsService } from './echarts.service';
import { BgEChartsComponent } from './bg-echarts.component';
export const COMPONENTS = [BgEChartsComponent];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    ...COMPONENTS
  ],
  declarations: [...COMPONENTS],
  providers: [EChartsService]
})
export class BgEChartsModule { }
